var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCookie = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 59
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.74.18c14.216 0 25.74 11.524 25.74 25.74 0 1.036-.061 2.058-.18 3.062l-.09-.002a6.927 6.927 0 00-6.236 3.906 6.93 6.93 0 00-7.758 4.226 6.93 6.93 0 00-6.24 7.383 6.921 6.921 0 00-2.896 5.635c0 .484.05.956.144 1.412-.816.078-1.645.118-2.484.118C11.524 51.66 0 40.136 0 25.92S11.524.18 25.74.18z",
  fill: "#EFA259"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.648 10.461a4.453 4.453 0 118.908.001 4.453 4.453 0 01-8.908 0M2.16 21.938a3.06 3.06 0 116.124 0 3.06 3.06 0 01-6.124 0m36.413 2.196a2.227 2.227 0 114.454 0 2.227 2.227 0 01-4.454 0m-9.74-20.517a3.618 3.618 0 117.237 0 3.618 3.618 0 01-7.237 0M8.744 33.042a4.73 4.73 0 119.462 0 4.73 4.73 0 01-9.462 0M35.026 13.64a4.73 4.73 0 119.461 0 4.73 4.73 0 11-9.461 0m-15.444 1.326a3.059 3.059 0 013.061-3.06 3.06 3.06 0 110 6.12 3.06 3.06 0 01-3.06-3.06M12.9 47.909a3.618 3.618 0 117.237-.002 3.618 3.618 0 01-7.237.002",
  fill: "#873F21"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EFA259",
  cx: 34.83,
  cy: 52.47,
  r: 2.43
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#873F21",
  cx: 41.04,
  cy: 50.04,
  r: 1.62
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EFA259",
  cx: 50.4,
  cy: 33.12,
  r: 1.62
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EFA259",
  cx: 41.31,
  cy: 57.51,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#873F21",
  cx: 28.89,
  cy: 29.43,
  r: 6.93
}))));

export default SvgCookie;